import React, { Component } from 'react';
import {
    // Collapse,
    Navbar,
    // NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Container,
    // UncontrolledDropdown,
    // DropdownItem,
    // DropdownToggle,
    // DropdownMenu
    Popover,
    PopoverHeader,
    PopoverBody
} from 'reactstrap';

import './MainArea.css';

class NavigationBar extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.togglePopover = this.togglePopover.bind(this);

        this.state = {
            isOpen: false,
            popoverOpen:false
        };
    }
    toggle() {
        this.setState({
        isOpen: !this.state.isOpen
        });
    }
    togglePopover() {
        this.setState({
            popoverOpen:!this.state.popoverOpen
        })
    }

    render() {
        return (
            <div>

            <Navbar style={{backgroundColor:"#202020"}}  dark expand="md">
            
            <Container fluid>
                
                <NavbarBrand style={{fontFamily:"PirataOne", color:"#ffffff"}} ><i className="fas fa-bars" onClick={this.props.toggleSidebar} style={{color:"#ffffff", width:"40px", cursor:"pointer"}}></i>  
                    {!this.props.scenarioLoaded ? "Gloomhaven Monster Tracker" : this.props.scenarioName + ": Level " + this.props.scenarioLevel}

                </NavbarBrand>
                {/* <NavbarToggler onClick={this.toggle} /> */}
                {/* <Collapse isOpen={this.state.isOpen} navbar> */}
                    <Nav className="ml-auto" navbar>
                        <NavItem>
                            <NavLink id="help" className="mx-auto" onClick={this.togglePopover} style={{cursor:"pointer"}}><i className="fas fa-info-circle"></i></NavLink>
                            <Popover placement="auto" isOpen={this.state.popoverOpen} target="help" toggle={this.togglePopover}>
                                <PopoverHeader>Help/Tips</PopoverHeader>
                                <PopoverBody>
                                    <ul>
                                        <li>Load a scenario, or add individual monsters from the sidebar menu</li>
                                        <li>To save vertical space, click the monster thumbnail to collapse the stats card</li>
                                        <li>Clicking on a monster image opens a popup
                                            <ul>
                                                <li>remove monster type</li>
                                                <li>change player count (for boss HP, default 4)</li>
                                            </ul>
                                        </li>
                                        <li>Click on an individual monster's active status effect to remove it</li>
                                    </ul>
                                </PopoverBody>
                            </Popover>
                        </NavItem>

                    {/* <NavItem>
                        <NavLink className="mx-auto" href="#">{this.props.scenarioName}</NavLink>
                    </NavItem> */}
                    {/* <NavItem>
                        {this.props.scenarioLevel !== 0 ? <NavLink href="#">Level {this.props.scenarioLevel}</NavLink> : null}
                        
                    </NavItem> */}
                    {/* <UncontrolledDropdown nav inNavbar>
                        <DropdownToggle nav caret>
                        Options
                        </DropdownToggle>
                        <DropdownMenu >
                        <DropdownItem>
                            Option 1
                        </DropdownItem>
                        <DropdownItem>
                            Option 2
                        </DropdownItem>
                        <DropdownItem divider />
                        <DropdownItem>
                            Reset
                        </DropdownItem>
                        </DropdownMenu>
                    </UncontrolledDropdown> */}
                    </Nav>
                {/* </Collapse> */}
            </Container>
            </Navbar>

                
            </div>
        )
    }
}

export default NavigationBar;


// WEBPACK FOOTER //
// ./src/components/NavigationBar.js